export default __webpack_public_path__ + "static/media/verification.e29fbdce.svg";